    function Header_Text({Header, Text}){
        return (
        <div>
            <h1>
                {Header}
            </h1>
            <p>
                {Text}
            </p>
        </div>
        )
    }


    export default Header_Text;